import { Modal, Button } from 'react-bootstrap';

const Modalpopup = (props) => {

  return (
    <Modal className={`white-modal-popup ${props.myClassName ? props.myClassName : ''}`} show={props.showModal}
      onHide={props.onClose} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
      <Modal.Header closeButton={props.isStatic ? false : true}>
        <Modal.Title>{props.modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.children}
      </Modal.Body>
      {
        props.showModalFooter ?
          (<Modal.Footer>
            {props.soldPopup ?
              <p className="soldpopup-note-message orange-text-color"><span>Note:</span> Interest will be accrued till the day of the payment.</p>
              : ''}
            <Button onClick={props.onClose} variant="outline-secondary" className="md-btn btn-readius blue-outline-btn blue-link-text">Cancel</Button>
            <Button onClick={props.onSubmitAction} variant="primary" className="btn-readius md-btn">{props.soldPopup ? 'Next' : 'Submit'}</Button>
          </Modal.Footer>) : null
      }
    </Modal>
  )

}

export default Modalpopup;